import { Maximize2Icon, Minimize2Icon } from 'lucide-react';
import type { JSX } from 'react';

import { Button } from '@/components/ui/button.js';
import { cn } from '@/lib/utils.js';

/** Finds the full-screen button, so a viewer can focus it again after its toolbar moves. */
export const FULL_SCREEN_TOGGLE_SELECTOR = '[data-full-screen-toggle]';

/** The dialog classes that make it fill the window: the artifact viewer's full screen and the side panel's. */
export const MAXIMIZED_DIALOG_CLASS =
  'max-w-none w-screen h-[var(--app-height,100dvh)] max-h-none rounded-none border-0';

/** The full-screen button: its label says what a press does, and the tooltip names the F shortcut. */
export function FullScreenToggle({
  maximized,
  onToggle,
  className,
  shortcutHint = true,
}: {
  maximized: boolean;
  onToggle: () => void;
  className?: string;
  /** Whether the tooltip names the F shortcut; off where no F shortcut is wired. */
  shortcutHint?: boolean;
}): JSX.Element {
  const label = maximized ? 'Exit full screen' : 'Full screen';
  return (
    <Button
      variant="ghost"
      size="icon-sm"
      aria-label={label}
      title={shortcutHint ? `${label} (F)` : label}
      data-full-screen-toggle=""
      className={cn('hidden sm:inline-flex', className)}
      onClick={onToggle}
    >
      {maximized ? (
        <Minimize2Icon className="size-4" />
      ) : (
        <Maximize2Icon className="size-4" />
      )}
    </Button>
  );
}
